import { text } from "svelte/internal";
import { AudioManager, Track } from "../../AudioManager";
import { SetStyles, Point, Size, CreateElement, LogGroup, Scale} from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Settings } from "../../Settings";
import { CanvasSprite, CanvasSpriteSizing } from "../Sprite/CanvasSprite";
import { ICometInterface, ICometInterfacePIXIAPP } from "./ICometInterface";
import * as PIXI from 'pixi.js';
import { CometDefaultPIXIAPP } from "./CometDefaultPIXIAPP";

export class CometDefaultPIXIAPPResponsive extends CometDefaultPIXIAPP implements ICometInterfacePIXIAPP
{
    public constructor(audio : AudioManager , resid : ResourceIdentifier , reelsCoverAnotherScreen : boolean , fps : number){
        super(audio , resid , reelsCoverAnotherScreen , fps);
    }
   
    public override ViewPIXIAPP(): PIXI.Container<PIXI.DisplayObject> {
        return this.viewPIXIAPP;
    }

    public override PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        super.PrepareResources(resourceManager);
    }

    public override ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        super.ResourcesLoaded(resourceManager);

    }

    public override Start(source: Point, dest: Point)
    {
        //restart pixi anim 
        this.cometAnimatedSprite.gotoAndStop(0);
        // Define the points on the texture


        const textureStart = { x: Scale.X(148), y: Scale.Y(544) }; // Example coordinates on the texture
        const textureEnd = { x: Scale.X(148), y: Scale.Y(155) }; // Example coordinates on the texture

        // Define the target points on the screen
        const targetStart = source; //{ x: 200, y: 200 }; // Desired screen coordinates
        const targetEnd = dest; //{ x: 600, y: 500 }; // Desired screen coordinates

        // Create a sprite with the texture
        const sprite = this.cometAnimatedSprite; //new PIXI.Sprite(texture);

        // Calculate the distance between the points
        const distanceTexture = Math.sqrt((textureEnd.x - textureStart.x) ** 2 + (textureEnd.y - textureStart.y) ** 2);
        const distanceTarget = Math.sqrt((targetEnd.x - targetStart.x) ** 2 + (targetEnd.y - targetStart.y) ** 2);

        // Calculate the scale factor
        const scale = distanceTarget / distanceTexture;
        sprite.scale.set(scale);

        // Calculate the angle between the points
        const angleTexture = Math.atan2(textureEnd.y - textureStart.y, textureEnd.x - textureStart.x);
        const angleTarget = Math.atan2(targetEnd.y - targetStart.y, targetEnd.x - targetStart.x);
        const rotation = angleTarget - angleTexture;
        sprite.rotation = rotation;

        // Adjust for rotation around the correct pivot
        sprite.pivot.set(textureStart.x, textureStart.y);

        // Position the sprite such that the texture's start point aligns with the target start point
        sprite.position.set(targetStart.x, targetStart.y);
       
        this.cometAnimatedSprite.play();           
        this.cometAnimatedSprite.visible = true;
        //this.cometAnimatedSprite.scale.set(scaleWidth,scaleHeight);
    }

    public override StopsCommets() {
        //this.canvasSprite.Stop();
        //this.canvasSprite.Hide();
        this.cometAnimatedSprite.stop();
        this.cometAnimatedSprite.visible = false;
        this.cometAnimatedSprite.gotoAndStop(0);
    }

    public override SpriteComplete(): void {
        //this.canvasSprite.Hide();
        this.cometAnimatedSprite.visible = false;        
        this.OnCompleteCallback?.();
    }

    public override CreatePIXIAPP() : PIXI.Container{
        this.viewPIXIAPP = new PIXI.Container();
        this.viewPIXIAPP.name = "cometViewPIXIAPPResponsive";
        //this.viewPIXIAPP.width = Settings.ScreenWidth;
        //this.viewPIXIAPP.height = Settings.ScreenHeight * Settings.Screens;
        // if(this.reelsCoverAnotherScreen == false )this.viewPIXIAPP.y = Settings.ScreenHeight * (Settings.Screens - 1);
        
        
        this.spriteContainerPIXIAPP = new PIXI.Container();
        this.spriteContainerPIXIAPP.name = "spriteContainerPIXIAPP";
        this.spriteContainerPIXIAPP.width = this.canvasSprite.sprite.Size().Width;
        this.spriteContainerPIXIAPP.height = this.canvasSprite.sprite.Size().Height;        
        //this.spriteContainerPIXIAPP.pivot.set(this.canvasSprite.Size().width/2,this.canvasSprite.Size().height /2 );
        this.viewPIXIAPP.addChild(this.spriteContainerPIXIAPP);
       

        this.cometAnimatedSprite =  new PIXI.AnimatedSprite(this.TexturesCometFrame); 
        //this.cometAnimatedSprite.animationSpeed = this.fps / this.cometAnimatedSprite.totalFrames;       
        this.cometAnimatedSprite.width = this.canvasSprite.sprite.Size().Width;
        this.cometAnimatedSprite.height = this.canvasSprite.sprite.Size().Height;
        this.cometAnimatedSprite.onComplete=()=>{
            this.SpriteComplete();
        }
        //this.cometAnimatedSprite.anchor.set(0.5,1);
        this.cometAnimatedSprite.loop = false;
        this.cometAnimatedSprite.visible = false;
        
        this.spriteContainerPIXIAPP.addChild(this.cometAnimatedSprite);

        //this.OriginOffsetY = 0.87 * this.canvasSprite.sprite.Size().height;
        //console.log("CenterOriginPivot-SizeHeight:",this.canvasSprite.sprite.Size().height);
        //console.log("CenterOriginPivot:",this.OriginOffsetY);
        // this.viewPIXIAPP.position.set(Scale.X(450),Scale.H(-700));
        // this.viewPIXIAPP.scale.set(0.5);

        return this.viewPIXIAPP;
    }

    // public UpdateCometAnimation(celebrationFactor: number) {
    //     this.canvasSprite.sprite.SetFPS(this.canvasSprite.sprite.GetFPS()*celebrationFactor)
        
    // }
}